import styled from 'styled-components'

interface IFilePreviewStyledProps {}

export const FilePreviewStyled = styled.div<IFilePreviewStyledProps>`
  position: relative;

  height: 100%;
  width: 100%;

  background-color: #fff;
`
